(function () {
	'use strict';

	angular
		.module('wizard-future7.configs', [])
		.config(InterceptorConfig);

	/** @ngInject */
	function InterceptorConfig() {

	}
}());